export type BrandContentMap = Record<string, string>;

export interface IUiContentState {
  brandContent: BrandContentMap;
}

export const defaultUiContentState: IUiContentState = {
  brandContent: {},
};
